<template>
    <br><br>
    <!-- About section start -->
	<section id="about-section" class="px-12 lg:px-32 py-16 border-t border-stone-500 relative text-justify">
        <!-- Main text start -->
		<h1 class="uppercase text-5xl mb-4 font-semibold about-title">
        <strong>{{ $t('about.aboutUs') }}</strong>
		</h1> <br>
		<p class="xl:w-1/2 text-stone-500 mb-8 about-text">
            {{ $t('about.we') }}
        <br><br>{{ $t('about.trust') }} <router-link :to="{ path: '/about', hash: '#aboutView' }" class="mx-4 text-[#132e63]"><strong>{{ $t('about.more') }}</strong></router-link>
		</p> 
		<!-- Main text end -->

        <!-- Circle start -->
        <div class="bg-neutral-200 h-44 w-44 md:h-52 md:w-52 rounded-full absolute top-0 -left-20 mt-16 -z-20 opacity-20"></div>
        <!-- Circle end -->
	</section>
	<!-- About section end -->
</template>

<script>
export default {

}
</script>

<style>
#about-section {
    background-color: #f9f9f9;
}
.about-title {
    color: #132e63; 
}
.about-text {
    color: #051328 !important; 
}
</style>